// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1VHKf","bigColWidth":"Table_bigColWidth__13KzT","biggerColWidth":"Table_biggerColWidth__3MrpC","row":"Table_row__1Kqms","col":"Table_col__38gKp"};